import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminPostsPage = lazy(() => import('../pages/admin/posts/page'));
const AdminPostEditorPage = lazy(() => import('../pages/admin/posts/editor'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:id',
    element: <BlogPostPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/admin/posts',
    element: <AdminPostsPage />
  },
  {
    path: '/admin/posts/new',
    element: <AdminPostEditorPage />
  },
  {
    path: '/admin/posts/:id',
    element: <AdminPostEditorPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;